<div *ngIf="reviewStageId !== undefined && reviewStageId !== null">
  <app-status-badge [colourScheme]="badgeColourScheme">
    {{reviewStageDisplayText}}
  </app-status-badge>
</div>
<div *ngIf="reviewStageId === undefined || reviewStageId === null">
    <app-yellow-dash [value]="null"></app-yellow-dash>
</div>